import StatisticsHelper from '../helpers/OldStatisticsHelper';
import URLHelper from '../helpers/URLHelper';

export default {
  addHashEventListener() {
    URLHelper.addEventListener(`popState`, event => {
      if(!event.state || event.state === {}) {
        return;
      }
      if(event.state.statistic) {
        this.beforeHashtagEvent();
        const { statistic } = event.state;
        if(this.statisticTypes.indexOf(statistic) === -1) {
          return;
        }
        this.updateSelectInput(statistic);
      }
    });
  },
  checkHashtag(predefined) {
    const hashtag = window.location.hash.replace(`#`, ``);
    if(this.statisticTypes.indexOf(hashtag) === -1) {
      if(predefined) {
        URLHelper.setHash(predefined.statistic);
        window.history.pushState(predefined, ``, URLHelper.parsedUrlObject.fullUrl);
      }
      return;
    }
    this.updateSelectInput(hashtag);
  },
  getClassByRevenueStatus(status) {
    switch(status) {
      case `nicht_beruecksichtigt`:
        return `rin-table__tr--light`;
      case `bezahlt`:
      case `offen`:
      case `teilzahlung`:
      case `ueberfaellig`:
      default:
        return null;
    }
  },
  getIconByRevenueStatus(status) {
    switch(status) {
      case `bezahlt`:
        return this.icons.invoicePayed;
      case `offen`:
        return this.icons.alertGreen;
      case `teilzahlung`:
        return this.icons.alertYellow;
      case `ueberfaellig`:
        return this.icons.alertRed;
      case `nicht_beruecksichtigt`:
        return this.icons.invoiceNotIncluded;
      default:
        return ``;
    }
  },
  getIconForRevenueTeam(revenue) {
    if(revenue.isNewPartner) {
      return this.icons.star;
    }
    if(revenue.teamSize === 0) {
      return this.icons.alertRed;
    }
    return ``;
  },
  setHashtag(value) {
    URLHelper.setHash(value.statistic);
    window.history.pushState(value, ``, URLHelper.parsedUrlObject.fullUrl);
  },
  async setUpline(data) {
    data.upline = await StatisticsHelper.getUpline(data.customerNumber);
  },
};
